// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable, Subject } from 'rxjs';

// --- HS Code
import { DemographicValueModel, UserDemographicSelectList, SelectListItem, DemographicModel } from '../../../models';
import { AppService } from '../app.service';
import { DemographicsBaseService } from '../system/demographics-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class UserDemographicsBaseService {
  protected _userDemographicValues$: BehaviorSubject<DemographicValueModel[]>;
  get userDemographicValues$(): Observable<DemographicValueModel[]> {
    return this._userDemographicValues$;
  }

  protected _userDemographicsList$: BehaviorSubject<UserDemographicSelectList[]>;
  get userDemographicsList$(): Observable<UserDemographicSelectList[]> {
    return this._userDemographicsList$;
  }

  protected _updateUserDemographicsResult$: Subject<boolean>;
  get updateUserDemographicsResult$(): Observable<boolean> {
    return this._updateUserDemographicsResult$;
  }

  constructor(protected appService: AppService, protected demographicService: DemographicsBaseService) {
    this._userDemographicValues$ = new BehaviorSubject<DemographicValueModel[]>(null);
    this._userDemographicsList$ = new BehaviorSubject<UserDemographicSelectList[]>(null);
    this._updateUserDemographicsResult$ = new Subject<boolean>();
  }

  abstract loadUserDemographicValues(): void;
  abstract updateUserDemographics(userDemographicValues: DemographicValueModel[]): Observable<boolean>;
  abstract updateUserDemographicsFromProfile(userDemographicValues: DemographicValueModel[]): void;

  protected _processUserDemographics(userDemographicValues: DemographicValueModel[]) {
    this.demographicService.demographics$.subscribe(demographics => {
      if (!demographics) {
        return;
      }

      const list = new Array<UserDemographicSelectList>();

      for (const demographic of demographics) {
        const userDemographicValue = userDemographicValues.find(udv => udv.demographicId === demographic.id);
        const itemsList = new Array<SelectListItem>();

        for (const value of demographic.values) {
          itemsList.push({
            isDisabled: false,
            isSelected: userDemographicValue && userDemographicValue.id === value.id,
            text: value.name,
            value: value.id
          } as SelectListItem);
        }

        const item = {
          demographics: itemsList,
          id: demographic.id,
          identifier: demographic.moniker,
          name: demographic.name,
          validationMessage: '',
          selectedItem: userDemographicValue && userDemographicValue.id
        } as UserDemographicSelectList;
        list.push(item);
      }

      this._userDemographicsList$.next(list);
    });
  }
}
